var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_242_15188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2225 0.000488281H1.7709C0.791211 0.000488281 -0.000976562 0.773926 -0.000976562 1.73018V22.2661C-0.000976562 23.2224 0.791211 24.0005 1.7709 24.0005H22.2225C23.2021 24.0005 23.999 23.2224 23.999 22.2708V1.73018C23.999 0.773926 23.2021 0.000488281 22.2225 0.000488281ZM7.11934 20.452H3.55684V8.9958H7.11934V20.452ZM5.33809 7.43486C4.19434 7.43486 3.2709 6.51143 3.2709 5.37236C3.2709 4.2333 4.19434 3.30986 5.33809 3.30986C6.47715 3.30986 7.40059 4.2333 7.40059 5.37236C7.40059 6.50674 6.47715 7.43486 5.33809 7.43486ZM20.4506 20.452H16.8928V14.8833C16.8928 13.5567 16.8693 11.8458 15.0412 11.8458C13.1896 11.8458 12.9084 13.2942 12.9084 14.7896V20.452H9.35527V8.9958H12.7678V10.5614H12.8146C13.2881 9.66143 14.4506 8.70986 16.1803 8.70986C19.785 8.70986 20.4506 11.0817 20.4506 14.1661V20.452Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_242_15188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInBlack);
export default __webpack_public_path__ + "static/media/linkedInBlack.16298168e6aad8634cae0fd2f346375a.svg";
export { ForwardRef as ReactComponent };